export const isAnomaly = (value, outOf, percentThreshold) => {
    if (!value)
        return false;
    // ... Either 2%, 40%, 275%
    const percentageChange = (value / outOf) * 100;
    // ... Check if is within the percentThreshold
    // ... Must be between 0 and 100
    // ... 100 - percentThreshold <= percentageChange <= 100 + percentThreshold
    const minimumPercentageChange = 100 - percentThreshold;
    const maximumPercentageChange = 100 + percentThreshold;
    return !(minimumPercentageChange <= percentageChange && percentageChange <= maximumPercentageChange);
};
export const lerp = (value, inMin, inMax, outMin, outMax) => {
    if (inMax === inMin)
        return outMax;
    const t = (value - inMin) / (inMax - inMin);
    return outMin + t * (outMax - outMin);
};
